import { axios } from '../../services/axios';

const getGCCHServiceProfile = async ({ scope }) => {
    const result = await axios.get(
        `/ServiceProfile/DirectRoutingGCCH/${scope}`,
    );
    return result;
};
export default getGCCHServiceProfile;
